module.exports = __webpack_public_path__ + "static/img/fall.e66d2770.png";